<template>
  <div id="app">
    <TheNavigation />
    <transition name="fade" mode="out-in">
      <router-view :key="$route.path" />
    </transition>
    <TheFooter />
  </div>
</template>

<script>
import TheNavigation from "@/components/TheNavigation";
import TheFooter from "@/components/TheFooter";

export default {
  components: {
    TheNavigation,
    TheFooter
  },
  watch: {
    '$route' (to, from) {
      // document.title = to.meta.title ? to.meta.title + ' - Houqi Li' : 'Houqi Li'
      document.title = to.meta.title ? to.meta.title : 'Houqi Li'
    }
  }
};
</script>

<style>
@import "assets/css/my.css";
@import url(https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css);
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
